import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
import { DataSyncServiceComponent } from './DataSyncServiceComponent';
export const DataSyncReconnectionConfig = {
  reconnectButton: null,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED],
  serviceComponent: DataSyncServiceComponent
};